var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.$tc(
      ("pages.user.profile.table.benefits." + _vm.programKind),
      _vm.amountTranslationIndex,
      { count: _vm.formattedValue }
    ))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }